// src/admin/pages/Restaurants/RestaurantDetailsPage.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TablesSection from "./TablesSection";
import MenusSection from "./MenusSection";

export default function RestaurantDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [restaurant, setRestaurant] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // "tables" o "menus"
  const [activeTab, setActiveTab] = useState("tables");

  useEffect(() => {
    fetchRestaurant();
    // eslint-disable-next-line
  }, [id]);

  const fetchRestaurant = async () => {
    setError("");
    setLoading(true);
    try {
      const token = localStorage.getItem("access_token");
      // Se il server risponde su /restaurants/:id, lascia così
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/restaurants/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (!res.ok) {
        throw new Error("Errore durante il caricamento del ristorante");
      }
      const data = await res.json();
      setRestaurant(data);
    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleBackClick = () => {
    // Torniamo alla pagina /admin/restaurants
    navigate("/admin/restaurants");
  };

  // Se c'è un errore, lo mostriamo
  if (error) {
    return <p style={styles.errorText}>{error}</p>;
  }

  // Se stiamo ancora caricando, feedback
  if (loading || !restaurant) {
    return <p style={styles.loadingText}>Caricamento dati del ristorante...</p>;
  }

  return (
    <div style={styles.container}>
      {/* HEADER */}
      <div style={styles.header}>
        <button style={styles.backButton} onClick={handleBackClick}>
          ←
        </button>
        <h2 style={styles.headerTitle}>{restaurant.name}</h2>
      </div>

      {/* CONTENUTO */}
      <div style={styles.content}>
        {activeTab === "tables" && <TablesSection restaurant={restaurant} />}
        {activeTab === "menus" && <MenusSection restaurant={restaurant} />}
      </div>

      {/* BOTTOM NAV (identica al WaiterDashboard style) */}
      <div style={styles.bottomNav}>
        <div
          style={activeTab === "tables" ? styles.navItemActive : styles.navItem}
          onClick={() => setActiveTab("tables")}
        >
          <span style={styles.navIcon}>🍽</span>
          <span style={styles.navLabel}>Tavoli</span>
        </div>

        <div
          style={activeTab === "menus" ? styles.navItemActive : styles.navItem}
          onClick={() => setActiveTab("menus")}
        >
          <span style={styles.navIcon}>📜</span>
          <span style={styles.navLabel}>Menù</span>
        </div>
      </div>
    </div>
  );
}

// Stili inline, simili a WaiterDashboard
const palette = {
  primary: "#FF7F00",
  background: "#FAFAFA",
  card: "#FFFFFF",
  textDark: "#333333",
};

const styles = {
  container: {
    position: "relative",
    minHeight: "100vh",
    backgroundColor: palette.background,
    display: "flex",
    flexDirection: "column",
    // Lasciamo spazio per la bottom nav
    paddingBottom: "70px",
    fontSize: "16px",
  },

  // Header in alto
  header: {
    width: "100%",
    padding: "10px 16px",
    backgroundColor: "#fff",
    borderBottom: "1px solid #ddd",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  backButton: {
    fontSize: "20px",
    background: "none",
    border: "none",
    cursor: "pointer",
    color: palette.primary,
  },
  headerTitle: {
    margin: 0,
    fontSize: "18px",
    color: palette.textDark,
    fontWeight: "bold",
  },

  // Contenuto
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    padding: "10px 16px",
  },

  // Bottom Nav
  bottomNav: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "70px",
    background: "#fff",
    boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    zIndex: 999,
  },
  navItem: {
    position: "relative",
    flex: 1,
    textAlign: "center",
    color: "#666",
    fontSize: "13px",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "color 0.2s",
  },
  navItemActive: {
    position: "relative",
    flex: 1,
    textAlign: "center",
    color: palette.primary,
    fontSize: "13px",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "color 0.2s",
  },
  navIcon: {
    fontSize: "24px",
    lineHeight: "24px",
    marginBottom: "2px",
  },
  navLabel: {
    fontSize: "12px",
  },

  errorText: {
    color: "red",
    padding: "16px",
  },
  loadingText: {
    color: "#777",
    padding: "16px",
  },
};
